export const SELLING_REGIONS = {
  AU: {
    id: 22,
    name: 'Australia',
    code: 'AU'
  },
  CA: {
    id: 47,
    name: 'Canada',
    code: 'CA'
  },
  GB: {
    id: 243,
    name: 'United Kingdom',
    code: 'GB'
  },
  US: {
    id: 244,
    name: 'United States',
    code: 'US'
  }
}

export const OPPORTUNITY_EXPORT_TYPES = {
  QUOTE_PDF: {
    name: 'quote_pdf'
  },
  SALES_FLYER_PDF: {
    name: 'flyer_pdf'
  },
  GUEST_DOCUMENTATION: {
    name: 'guest_documentation'
  },
  WEBLINK: {
    name: 'weblink'
  },
  AGENT_WEBLINK: {
    name: 'agent_weblink'
  },
  LANDING_PAGE: {
    name: 'landing_page'
  }
}

export const OPPORTUNITY_EXPORT_SECTIONS_IDS = {
  COVER: 1,
  LETTER: 2,
  ITINERARY: 3,
  INCLUSIONS: 4,
  TERMS_CONDITIONS: 5,
  BOOK_MY_GROUP: 6,
  CONTACT_US: 7,
  MAP: 8,
  PRICING: 9,
  DATES: 10,
  AIR_CONTRACT: 11,
  SHIP_DETAILS: 12
}

export const OPPORTUNITY_TYPES_IDS = {
  SCHEDULED: 2,
  CUSTOM: 18
}
